import React from 'react';
import styled from 'styled-components';
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const CalendarCardContainer = styled.div`
  border: 1px solid #d0d0d0;
  padding: 20px;
  background-color: #ffffff;
`;

const CalendarButton = styled.button`
  margin-right: 12px;
  margin-top: 6px;
`;

const CalendarCard = () => {
  return (
    <CalendarCardContainer>
      <h3>View central outreach calendar</h3>
      <p>
        Student Success Innovations in the Office of the Provost manages a
        central outreach calendar to help ASU units coordinate and optimize
        communication efforts.
      </p>
      <p>
        Please review the outreach calendar to coordinate your communications.
      </p>
      <a
        href="https://airtable.com/appSWFBDWOEeaeoDa/shrefsQL38ZcYxyz0/tblciOGfLYMGCtvB4"
        target="_blank"
        rel="noopener noreferrer"
        data-ga-event="link"
        data-ga-action="click"
        data-ga-name="onclick"
        data-ga-type="external link"
        data-ga-region="main content"
        data-ga-section="Campaign Builder Home"
        data-ga-component=""
        data-ga-text="View central outreach calendar in calendar view"
      >
        <CalendarButton type="button" className="btn btn-md btn-maroon btn-sm">
          <FontAwesomeIcon icon={faExternalLinkAlt} /> Calendar view
        </CalendarButton>
      </a>
      <a
        href="https://links.asu.edu/studentoutreachlist"
        target="_blank"
        rel="noopener noreferrer"
        data-ga-event="link"
        data-ga-action="click"
        data-ga-name="onclick"
        data-ga-type="external link"
        data-ga-region="main content"
        data-ga-section="Campaign Builder Home"
        data-ga-component=""
        data-ga-text="View central outreach calendar in list view"
      >
        <CalendarButton type="button" className="btn btn-md btn-maroon btn-sm">
          <FontAwesomeIcon icon={faExternalLinkAlt} /> List view
        </CalendarButton>
      </a>
    </CalendarCardContainer>
  );
};

export { CalendarCard };
